module.exports = __webpack_public_path__ + "img/taizhou.cc9c6d8.png";